import { Link } from "react-router-dom";
import { excerpt } from "../utils/text";
import { getCategoryPillClass } from "../utils/categoryColor";

export default function ImageCard({ item }) {
  return (
    <Link to={`/post/${item.id}`} className="image-card">
      <div className="image-card-media">
        <img src={item.image} alt={item.title} loading="lazy" />
      </div>
      <div className="image-card-body">
        {item.category && (
          <span className={`pill ${getCategoryPillClass(item.category)}`}>
            {item.category}
          </span>
        )}
        <p className="image-card-title">{item.title}</p>
        {item.description && (
          <p className="image-card-excerpt">{excerpt(item.description)}</p>
        )}
      </div>
    </Link>
  );
}
